import styled from '@emotion/styled';
import { useIsMobile } from '@hooks/responsive/useIsMobile';
import { NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Head from 'next/head';
import { useRouter } from 'next/router';

// components
import ErrorIcon from '@public/assets/3dIcons/3dRedError.svg';
import Button from '@components/_atoms/Button';
import Typography from '@components/_atoms/Typography';
import DefaultLayout from '@components/_templates/DefaultLayout';
import withAuth from '@components/hocs/withAuth';

// constants
import { ButtonColor, TypoVariant } from '@constants/atoms';
import { MOBILE_MODE } from '@constants/size';
import { gray, primary } from '@styles/Colors';
import ButtonCode from '@constants/log/buttonCode';

const DeadWrapper = styled.div`
  width: 100%;
  max-width: 528px;
  padding: 336px 0;
  margin: 0 auto;
  text-align: center;

  @media ${MOBILE_MODE} {
    max-width: 320px;
    padding: 200px 0;
  }
`;

const TitleWrapper = styled.div`
  margin-top: 32px;
`;

const ContentWrapper = styled.div`
  margin: 8px auto 80px;

  @media ${MOBILE_MODE} {
    margin-bottom: 124px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

const Dead: NextPage = () => {
  const { t } = useTranslation('seller');
  const router = useRouter();
  const isMobile = useIsMobile();

  return (
    <>
      <Head>
        <title>{t('detail.dead.meta-title')}</title>
        <meta name="title" content={t('detail.dead.meta-title')} />
      </Head>
      <DefaultLayout>
        <DeadWrapper>
          <ErrorIcon />
          <TitleWrapper>
            <Typography variant={isMobile ? TypoVariant.SH2 : TypoVariant.H6} color={primary.gray}>
              {t('detail.dead.title')}
            </Typography>
          </TitleWrapper>
          <ContentWrapper>
            <Typography variant={isMobile ? TypoVariant.B3 : TypoVariant.B2} color={gray.gray7}>
              {t('detail.dead.content')}
            </Typography>
          </ContentWrapper>
          <ButtonWrapper>
            <Button
              width={isMobile ? '100%' : ''}
              text={t('detail.dead.back-button')}
              color={ButtonColor.OutlinedGray}
              onClick={() => router.back()}
              steelbosoId={ButtonCode.BTN_BACK}
            />
          </ButtonWrapper>
        </DeadWrapper>
      </DefaultLayout>
    </>
  );
};

export const getStaticProps = async ({ locale }: { locale: any }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['seller', 'component', 'common'])),
  },
});

export default Dead;
